// removed by extract-text-webpack-plugin
module.exports = {"container":"_2F6Lz90u6IN6gPpO0uq1kO","label":"_3UI7_S6BBWU11Lqk89_Lpb"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Sign/PrepareTemplate/Field/Menu/Checkbox/styles.css
// module id = 3136
// module chunks = 0